import { Redirect, RedirectProps } from "react-router-dom";
import { usePropsToWithUTM } from "../../helpers/usePropsToWithUTM";

export function RedirectKeepUTM(props: RedirectProps) {
  return <Redirect {...usePropsToWithUTM(props)} />;
}
